/*
 * @Description: 
 * @Date: 2019-10-24 11:02:13
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-28 13:54:14
 */
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi'
    },
    // 自定义主题
    theme: {
        themes: {
            light: {
                primary: '#3949ab',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
            },
        },
    },
});